import { createAsyncThunk } from "@reduxjs/toolkit";
import ApiService from "redux/ApiService/ApiService";
import Sessions from "utils/Sessions";

const getProjectTrackerData = createAsyncThunk("projectTracker/api", async (params, { signal }) => {
  const projectId = typeof params === "object" ? params?.projectId : params;
  const trackerDate = typeof params === "object" ? params?.trackerDate : "";
  const endPoint = trackerDate
    ? `reports/project-tracker/${projectId}?trackerDate=${trackerDate}`
    : `reports/project-tracker/${projectId}`;
  const requestSignal = typeof params === "object" ? params?.signal || signal : signal;

  const res = await ApiService.get(endPoint, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
    signal: requestSignal,
  });

  return res;
});

export default getProjectTrackerData;
